import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowBox = () => {
  return (
    <g>
      <path d="m1.05 2 4.2.006A.75.75 0 0 1 5.354 3.5l-.102.007L1.5 3.5V14.5h11v-3.75a.75.75 0 0 1 1.5 0v4.2c0 .541-.41.987-.936 1.044L12.95 16H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.95V3.05c0-.54.41-.986.936-1.043L1.05 2zM15.3 0a.7.7 0 0 1 .7.7v6.55a.75.75 0 1 1-1.5 0V2.561L9.27 7.789a.75.75 0 0 1-1.133-.976l.073-.084L13.438 1.5H8.75a.75.75 0 0 1 0-1.5h6.55z" />
    </g>
  );
};

export default withIcon(IconArrowBox);
